import { DashboardListRow } from '../DashboardListRow'

import { BirdviewGretaRowActions } from './BirdviewGretaRowActions'

function BirdviewGretaRow({ item }) {
  return (
    <DashboardListRow
      Icon={item.Icon}
      Meta={BirdviewGretaRowActions}
      subtitle={item.why}
      title={item.title}
    />
  )
}

export default BirdviewGretaRow
